var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfdRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4902 33.8594C23.4902 35.0084 23.0986 35.9865 22.3154 36.792C21.5323 37.5975 20.5983 38 19.5146 38C18.4188 37.9999 17.4801 37.5946 16.6982 36.7842C15.9163 35.9734 15.5244 34.998 15.5244 33.8594H23.4902ZM19.4854 -2C20.4641 -1.99994 21.2943 -1.64199 21.9766 -0.926758C22.6589 -0.211411 23 0.657095 23 1.67871V2.47852C25.7194 3.1046 27.8805 4.5903 29.4824 6.93457C31.0842 9.27906 31.8848 11.9032 31.8848 14.8066V16.2588C31.3128 16.162 30.7213 16.1113 30.1104 16.1113C29.0848 16.1114 28.114 16.2473 27.1982 16.5205V14.8066C27.1982 12.611 26.4462 10.728 24.9434 9.1582C23.4403 7.58852 21.6211 6.80377 19.4854 6.80371C17.3495 6.80371 15.5295 7.58838 14.0264 9.1582C12.5236 10.728 11.7725 12.6111 11.7725 14.8066V27.1807H20.1611C20.3323 28.9782 20.9524 30.5884 22.0215 32.0127H4V27.1807H7.11523V14.8066C7.11523 11.9197 7.9129 9.30434 9.50977 6.96191C11.1069 4.61926 13.2605 3.12491 15.9697 2.47852V1.67871C15.9697 0.657169 16.311 -0.211441 16.9932 -0.926758C17.6755 -1.6421 18.5064 -2 19.4854 -2Z",
    fill: "#092B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 31.2083L35.5138 26L34.1667 24.6946L31.3054 27.5558V20.9029H29.4025V27.5558L26.5 24.6946L25.1942 26L30.3333 31.2083ZM24.3679 31.76C22.7893 30.1922 22 28.2964 22 26.0725C22 23.8483 22.7893 21.9469 24.3679 20.3683C25.9465 18.7894 27.8424 18 30.0554 18C32.2685 18 34.1643 18.7882 35.7429 20.3646C37.3215 21.9407 38.1108 23.8469 38.1108 26.0833C38.1108 28.3044 37.3215 30.1978 35.7429 31.7633C34.1643 33.3286 32.2685 34.1113 30.0554 34.1113C27.8424 34.1113 25.9465 33.3275 24.3679 31.76Z",
    fill: "#092B4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfdRequest);
export default __webpack_public_path__ + "static/media/NFDRequest.ee993a75cdb2ae2c5da921bf4b24dc35.svg";
export { ForwardRef as ReactComponent };